export default "__VITE_ASSET__d2df45c6__"